import { ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

interface TuiButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
}

export const TuiButton = forwardRef<HTMLButtonElement, TuiButtonProps>(
  ({ className, variant = "primary", size = "md", children, ...props }, ref) => {
    const sizes = {
      sm: "h-7 px-3 text-[11px]",
      md: "h-9 px-4 text-xs",
      lg: "h-11 px-6 text-sm",
    };
    const variants = {
      primary:
        "bg-primary text-primary-foreground border border-primary hover:bg-primary/90 font-bold",
      ghost:
        "bg-transparent text-foreground border border-border hover:border-primary hover:text-primary",
      danger:
        "bg-transparent text-destructive border border-destructive/50 hover:bg-destructive hover:text-destructive-foreground",
    };
    return (
      <button
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center gap-2 font-mono uppercase tracking-[0.15em] transition-colors disabled:opacity-40 disabled:cursor-not-allowed",
          sizes[size],
          variants[variant],
          className,
        )}
        {...props}
      >
        {children}
      </button>
    );
  },
);
TuiButton.displayName = "TuiButton";
